// Canonical UUID v4-ish matcher shared by the geometry routes (and fixture
// tests). Lives here rather than in a route module so route files don't import
// each other for it.
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The value when it is a UUID string, else `undefined` — for search params. */
export function asUuid(value: unknown): string | undefined {
  return typeof value === 'string' && UUID_REGEX.test(value)
    ? value
    : undefined;
}
